module.exports = __webpack_public_path__ + "img/chart-live.17b172e3.svg";